import { Controller } from "@hotwired/stimulus"

function extractHostname(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "").toLowerCase()
  } catch {
    return url.replace(/^(https?:\/\/)?(www\.)?/i, "").split("/")[0].toLowerCase()
  }
}

export default class extends Controller {
  static targets = ["input", "modal", "modalIcon", "modalTitle", "modalBody", "loginModal"]
  static values = { messages: Array, loggedIn: Boolean }

  inputTargetConnected() {
    this.inputTarget.addEventListener("input", () => this.inputTarget.setCustomValidity(""))
  }

  normalize(event) {
    let val = this.inputTarget.value.trim()
    if (val && !val.match(/^https?:\/\//i)) {
      val = `https://${val}`
      this.inputTarget.value = val
    }

    const host = extractHostname(val)

    if (!host || !host.includes(".")) {
      event.preventDefault()
      this.inputTarget.setCustomValidity("Please enter a valid domain (e.g. example.com)")
      this.inputTarget.reportValidity()
      return
    }

    this.inputTarget.setCustomValidity("")

    if (host === "readyforai.dev" && this.messagesValue.length > 0) {
      event.preventDefault()
      this.showSelfCheckModal()
      return
    }

    // A scan needs an account; "log in to check" sends the form on, and the server keeps the address
    if (!this.loggedInValue && !this.loginConfirmed) {
      event.preventDefault()
      this.openModal(this.loginModalTarget)
    }
  }

  confirmLogin() {
    this.loginConfirmed = true
    this.element.querySelector("form").requestSubmit()
  }

  closeLoginModal() {
    this.closeModal(this.loginModalTarget)
  }

  showSelfCheckModal() {
    const messages = this.messagesValue
    const msg = messages[Math.floor(Math.random() * messages.length)]
    this.modalIconTarget.textContent = msg.icon
    this.modalTitleTarget.textContent = msg.title
    this.modalBodyTarget.textContent = msg.body
    this.openModal(this.modalTarget)
  }

  closeSelfCheckModal() {
    this.closeModal(this.modalTarget)
  }

  openModal(modal) {
    modal.classList.remove("hidden")
    modal.offsetHeight
    modal.querySelector("[data-panel]").classList.add("scale-100", "opacity-100")
  }

  closeModal(modal) {
    modal.querySelector("[data-panel]").classList.remove("scale-100", "opacity-100")
    setTimeout(() => modal.classList.add("hidden"), 200)
  }
}
